export default {
  // 数组 元素唯一时去除指定元素 返回去除的元素
  arr_remove_item: (arr, val) =>
    arr.splice(
      arr.findIndex(x => x === val),
      1
    ),
  // 数组 并集 仅一维数组
  arr_union: (arr1, arr2) => arr1.concat(arr2.filter(x => !arr1.includes(x))),
  // 数组 交集 仅一维数组
  // arr_intersection: (arr1, arr2) => arr1.filter(x => arr2.includes(x)),
  arr_intersection: (arr1, arr2) => {
    let set1 = [...new Set(arr1)]
    let set2 = new Set(arr2)
    return [...new Set(set1.filter(x => set2.has(x)))]
  },
  // 数组 差集 仅一维数组
  // arr_difference: (arr1, arr2) => arr1.concat(arr2).filter(x => !arr1.includes(x) || !arr2.includes(x)),
  arr_difference: (arr1, arr2) => {
    let set1 = new Set(arr1)
    let set2 = new Set(arr2)
    let set3 = new Set(arr1.filter(x => !set1.has(x)))
    let set4 = new Set(arr2.filter(x => !set2.has(x)))
    return [...set3, ...set4]
  },
  /** 数组 两个数组合并成一个对象数组 考虑到复杂度 所以目前支持两个一维数组
   * [1, 2], [3, 4, 5], 'a', 'b' => [{a: 1, b: 3}, {a: 2, b: 4}, {a: '', b: 5}]
   * [1, 2], [3, 4, 5] => {1: 3, 2: 4}
   * @param {Array} arr1 数组1
   * @param {Array} arr2 数组2
   * @param {String} key1 属性名1
   * @param {String} key2 属性名2
   * @returns
   */
  arr_merge_to_obj: (arr1, arr2, key1, key2) => {
    if (typeof arr1 === 'object' && typeof arr2 === 'object') {
      if (!key1 && !key2) {
        let obj = {}
        arr1.forEach((x, i) => {
          obj[x] = arr2[i]
        })
        return obj
      } else {
        const Length = Math.max(arr1.length, arr2.length)
        let newArr = []
        for (let i = 0; i < Length; i++) {
          let obj = {}
          obj[key1] = arr1[i] || ''
          obj[key2] = arr2[i] || ''
          newArr.push(obj)
        }
        return newArr
      }
    }
  },
  // 数组 合并，目前合并一维
  arr_concat: (arr1, arr2) => [...arr1, ...arr2],
  // 数组 求和
  arr_sum: arr => arr.reduce((prev, cur) => prev + cur, 0),
  // 数组 最大值
  arr_max: arr => Math.max(...arr),
  // 数组 最小值
  arr_min: arr => Math.min(...arr),
  // 数组 去重
  // arr_remove_repeat: arr => Array.from(new Set(arr)),
  arr_remove_repeat: arr => [...new Set(arr)],
  // 数组 排序，默认升序
  arr_sort: (arr, ascendFlag = true) =>
    arr.sort((a, b) => (ascendFlag ? a - b : b - a)),
  // 判断两个数组是否相等，目前只支持值为简单数据类型的判断
  arr_is_equal: (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false
    } else {
      for (let x = 0; x < arr1.length; x++) {
        if (arr1[x] !== arr2[x]) {
          return false
        }
      }
      return true
    }
  },
  // 数组 去除空值
  arr_clean: arr => arr.filter(x => x),
}
